import { render, staticRenderFns } from "./PanelUploadTable.vue?vue&type=template&id=07addd22&scoped=true&"
import script from "./PanelUploadTable.vue?vue&type=script&lang=js&"
export * from "./PanelUploadTable.vue?vue&type=script&lang=js&"
import style0 from "./PanelUploadTable.vue?vue&type=style&index=0&id=07addd22&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07addd22",
  null
  
)

export default component.exports